module.exports = __webpack_public_path__ + "static_portal/img/bg7-video_moment.f0fceec9.jpg";